<template>
  <div class="main-content-container container-fluid h-100">
    <d-row no-gutters class="h-100">
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="auth-form__logo d-table mx-auto mb-3"
              src="@/assets/images/spring-logo.svg"
              alt="Shards Dashboards - Login Template"
            />

            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">{{ $t("auth.logintitle") }}</h5>

            <!-- Form Fields -->
            <d-form @submit="login" method="post">
              <div class="form-group">
                <label for="exampleInputEmail1">{{ $t("auth.email") }}</label>
                <d-input
                  type="email"
                  id="exampleInputEmail1"
                  placeholder="Enter email"
                  v-model="email"
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">{{ $t("auth.password") }}</label>
                <d-input
                  type="password"
                  id="exampleInputPassword1"
                  placeholder="Password"
                  v-model="password"
                />
              </div>
              <div class="form-group mb-3 d-table mx-auto">
                <d-checkbox v-model="rememberMe">{{ $t("auth.remember") }}</d-checkbox>
              </div>

              <d-alert theme="danger" :show="errorMessage" dismissible>{{errorMessage}}</d-alert>

              <d-button
                type="submit"
                pill
                class="btn-accent login-btn d-table mx-auto"
                :disabled="isAuthLoading"
              >{{ isAuthLoading ? 'Logging in...' : 'Login' }}</d-button>
            </d-form>
          </d-card-body>
        </d-card>

        <!-- Meta Details -->
        <div class="auth-form__meta d-flex mt-4">
          <d-link class="cursor" tag="a" :to="{ name: 'forgot-password' }">{{ $t("auth.forgot") }}</d-link>
          <d-link tag="a" to="register" class="ml-auto cursor">{{ $t("auth.register") }}</d-link>
        </div>
      </d-col>
    </d-row>
  </div>
</template>
<script>
import { AUTH_AUTHENTICATE } from "@/store/types";
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      email: "",
      password: "",
      rememberMe: false,
      errorMessage: null
    };
  },
  computed: { ...mapGetters(["getCurrentUser", "isAuthLoading"]) },
  methods: {
    async login(e) {
      e.preventDefault();
      const { email, password, rememberMe } = this;

      try {
        await this.$store.dispatch(AUTH_AUTHENTICATE, {
          email,
          password,
          rememberMe
        });
        this.$router.push({ name: "analytics" });
      } catch (err) {
        this.errorMessage = err.response.data.error;
        console.log(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>


